import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { Alert, LoadingGeneric } from '../components/';
import { Login } from '../pages/Login';
import { DashboardRoutes } from './DashboardRoutes';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';

export const AppRouter = () => {
	const { user } = useSelector((state) => state.uReducer);
	const oauthParams =
		typeof window !== 'undefined'
			? new URLSearchParams(window.location.search)
			: undefined;
	const isAuthInProgress = Boolean(
		oauthParams?.get('code') && oauthParams?.get('state'),
	);

	return (
		<Router basename={`${process.env.REACT_APP_PUBLIC_URL}`}>
			<Alert />
			<LoadingGeneric />
			<Switch>
				<PublicRoute
					exact
					path="/auth"
					isAuthenticated={user}
					component={Login}
				/>
				<PrivateRoute
					path="/"
					isAuthenticated={user}
					isAuthInProgress={isAuthInProgress}
					component={DashboardRoutes}
				/>
			</Switch>
		</Router>
	);
};
